import { render, staticRenderFns } from "./expertSubmit.vue?vue&type=template&id=72a283be&title='%E9%80%9F%E6%B4%BE%E5%A4%A7%E5%92%96%E7%94%B3%E8%AF%B7'&"
import script from "./expertSubmit.vue?vue&type=script&lang=js&"
export * from "./expertSubmit.vue?vue&type=script&lang=js&"
import style0 from "./expertSubmit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports